export const reimbursementPoliciesPtBr = {
  settingsHub: {
    title: 'Reembolsos',
    tabs: {
      policies: 'Políticas',
      categories: 'Categorias',
      form: 'Formulário',
    },
  },
  title: 'Políticas de Reembolso',
  newPolicy: 'Nova Política',
  formFieldsButton: 'Campos do formulário',
  publicLinksButton: 'Links públicos',
  policiesCount: '{{count}} política',
  policiesCount_plural: '{{count}} políticas',
  filters: {
    entity: 'Todas as entidades',
  },
  searchPlaceholder: 'Buscar políticas...',
  statusAll: 'Todos status',
  statusActive: 'Ativas',
  statusInactive: 'Inativas',
  emptyTitle: 'Nenhuma política encontrada',
  emptyDescription: 'Ajuste os filtros ou crie uma nova política de reembolso.',
  refresh: 'Atualizar',
  intake: {
    pageTitle: 'Nova solicitação de reembolso',
    toasts: {
      created: 'Solicitação criada com sucesso',
      uploadPartial:
        'Solicitação criada, mas alguns anexos não foram enviados. Revise na lista de documentos ou tente novamente.',
    },
  },
  publicIntake: {
    pageTitle: 'Solicitação de reembolso',
    poweredBy: 'Desenvolvido por',
    pageSubtitle: 'Peça o código por e-mail e valide-o para continuar.',
    verifiedPageSubtitle: 'Código validado. Preencha os dados do reembolso para enviar o pedido.',
    requestCode: 'Solicitar código',
    validateCode: 'Validar código',
    companyIdentified: 'Empresa: {{tenantName}}',
    requestTitle: 'Dados do reembolso',
    requestDescription: 'Preencha os dados mínimos. Campos exigidos pela empresa: {{fields}}.',
    defaultFields: 'padrão',
    attachmentsNeedEmail:
      'Solicite o código com seu e-mail para habilitar o envio de comprovantes.',
    attachmentsRequiredHint: 'Envie pelo menos um comprovante (PDF ou imagem).',
    submit: 'Enviar solicitação',
    toasts: {
      codeSent: 'Código enviado',
      codeValidated: 'Código validado',
      requestSent: 'Solicitação enviada',
      uploadPartial:
        'Solicitação registrada, mas parte dos anexos não foi enviada. Procure o financeiro ou tente novamente.',
    },
    errors: {
      codeSend: 'Não foi possível enviar o código. Tente de novo em instantes.',
      invalidCode: 'Não foi possível validar o código.',
      validateBeforeSubmit: 'Valide o código antes de enviar',
      submit: 'Falha ao enviar',
      attachmentsRequired: 'Inclua pelo menos um comprovante.',
      uploadTokenMissing:
        'Não foi possível iniciar o envio dos anexos. Tente novamente ou contate o suporte.',
      invalidLink: 'Link público inválido, expirado ou revogado.',
      invalidEmail: 'Informe um e-mail válido (ex.: nome@empresa.com).',
      emailNotRegistered:
        'Não encontramos configuração de reembolso para o domínio deste e-mail. Use o e-mail corporativo indicado pela empresa ou fale com RH ou financeiro.',
      emailDomainNotAuthorized:
        'Este e-mail não pertence a um domínio autorizado neste formulário. Use o e-mail corporativo da empresa.',
      codeInvalidOrExpired:
        'Código incorreto ou expirado. Confira o e-mail recebido ou solicite um novo código.',
      tooManyCodeRequests:
        'Foram feitas muitas tentativas em pouco tempo. Aguarde alguns minutos e peça o código novamente.',
      emailSendFailed:
        'Não foi possível enviar o e-mail com o código. Tente novamente ou contate o suporte.',
      tenantUnavailable:
        'Não foi possível concluir o acesso. Tente mais tarde ou contate o suporte.',
      tenantNotReady:
        'A empresa ainda não terminou a configuração para reembolsos. Contate o administrador.',
      requestInvalid:
        'Não foi possível processar seu pedido. Verifique os dados e tente novamente.',
      networkError: 'Verifique sua conexão com a internet e tente de novo.',
    },
    hints: {
      useCorporateEmail: 'Use o e-mail autorizado pela sua empresa.',
      codeInEmail: 'Código por e-mail — verifique o spam.',
      autoVerifyFromEmail: 'Validando o código enviado por e-mail…',
    },
    success: {
      pageSubtitle: 'Confira as orientações abaixo para os próximos passos.',
      title: 'Solicitação enviada',
      lead: 'Recebemos seu pedido e os comprovantes enviados. A análise seguirá as regras e prazos da sua empresa.',
      step1: 'Aguarde o retorno do financeiro, RH ou seu gestor, conforme o processo interno.',
      step2:
        'Mantenha os comprovantes originais organizados até a conclusão do reembolso, se for o caso.',
      step3: 'Se precisar de ajuda, use os canais oficiais da empresa (financeiro ou RH).',
      newRequest: 'Cadastrar novo reembolso',
      trackRequest: 'Acompanhar solicitação',
      trackRequestNumbered: 'Acompanhar pedido {{index}}',
      batchTrackingLead:
        'Você enviou {{count}} pedidos. Use os links abaixo para acompanhar cada um.',
    },
    fields: {
      email: 'E-mail',
      code: 'Código',
      entity: 'Entidade',
      cpfCnpj: 'CPF/CNPJ',
      name: 'Nome do solicitante',
      merchant: 'Estabelecimento',
      totalAmount: 'Valor total dos comprovantes',
      requestedAmount: 'Valor solicitado',
      expenseDate: 'Data da despesa',
      reimbursementDueDate: 'Data solicitada para reembolso',
      pixKey: 'Chave Pix',
      description: 'Descrição',
      businessJustification: 'Justificativa',
      attachments: 'Anexos',
      expenseClassification: 'Classificação da despesa',
    },
  },
  intakeSettings: {
    title: 'Campos de entrada para reembolso',
    description:
      'Configure quais campos serão obrigatórios no formulário de solicitação de reembolso.',
    save: 'Salvar campos',
    saving: 'Salvando...',
    refresh: 'Recarregar',
    loading: 'Carregando configuração...',
    toggleAria: 'Alternar obrigatoriedade de {{field}}',
    errors: {
      title: 'Não foi possível carregar',
      load: 'Erro ao carregar campos obrigatórios',
    },
    toasts: {
      saved: 'Campos obrigatórios salvos',
      saveError: 'Erro ao salvar campos obrigatórios',
    },
    publicLink: {
      pageTitle: 'Links públicos de reembolso',
      pageSubtitle:
        'Crie, copie e revogue links persistentes para o formulário público de solicitações.',
      title: 'Link público para funcionários',
      formsTitle: 'Formulários de reembolso',
      description:
        'Gere um link público persistente para enviar aos funcionários. O link usa os campos obrigatórios configurados acima.',
      entityLabel: 'Entidade',
      entityPlaceholder: 'Selecione a entidade',
      descriptionLabel: 'Descrição do link',
      descriptionPlaceholder: 'Ex: reembolsos de viagem',
      availabilityLabel: 'Disponibilidade',
      availabilityOptions: {
        INDEFINITE: 'Indefinido',
        ONE_HOUR: '1 hora',
        ONE_DAY: '1 dia',
        FIVE_DAYS: '5 dias',
        THIRTY_DAYS: '30 dias',
      },
      accessModeLabel: 'Quem pode solicitar',
      accessModeOptions: {
        HCM_EMPLOYEES: 'Colaboradores no HCM',
        COMPANY_DOMAIN: 'Domínio da empresa',
        PUBLIC: 'Público',
      },
      accessModeHints: {
        HCM_EMPLOYEES:
          'Somente e-mail de colaborador ativo no HCM. O código enviado ao e-mail continua obrigatório.',
        COMPANY_DOMAIN:
          'Aceita e-mails cujo domínio está em uma caixa de entrada ativa como @domínio, mesmo sem cadastro no HCM. E-mail completo ou lista vazia não libera o domínio. O código enviado ao e-mail continua obrigatório.',
        PUBLIC: 'Aceita qualquer e-mail válido. O código enviado ao e-mail continua obrigatório.',
      },
      generate: 'Gerar link',
      generated: 'Link gerado',
      linkColumn: 'Link',
      open: 'Abrir em nova aba',
      empty: 'Nenhum link criado.',
      createNew: 'Criar novo link',
      activeHint: 'Copie e envie este link aos funcionários autorizados.',
      indefiniteHint: 'Disponível por tempo indeterminado.',
      expiresAt: 'Disponível até {{date}}.',
      expiredHint: 'Este link expirou e não pode mais ser usado.',
      revokedHint: 'Este link foi revogado e não pode mais ser usado.',
      copy: 'Copiar',
      revoke: 'Revogar',
      toasts: {
        generated: 'Link público gerado',
        copied: 'Link copiado para a área de transferência',
        copyError: 'Não foi possível copiar o link',
        entityRequired: 'Selecione uma entidade para gerar o link',
        descriptionRequired: 'Informe uma descrição para gerar o link',
        generateError: 'Não foi possível gerar o link público',
        revoked: 'Link público revogado',
        revokeError: 'Não foi possível revogar o link público',
      },
      errors: {
        load: 'Não foi possível carregar os links públicos',
      },
    },
    fields: {
      DESCRIPTION: {
        label: 'Descrição',
        description: 'Descrição detalhada da despesa.',
      },
      ATTACHMENTS: {
        label: 'Anexos',
        description: 'Comprovantes e recibos da despesa.',
      },
      TOTAL_AMOUNT: {
        label: 'Valor total dos comprovantes',
        description: 'Valor total dos comprovantes da despesa original.',
      },
      REQUESTED_AMOUNT: {
        label: 'Valor solicitado',
        description: 'Valor que será solicitado para reembolso.',
      },
      PIX_KEY: {
        label: 'Dados para pagamento',
        description: 'Chave Pix ou dados bancários (TED) para o pagamento do reembolso.',
      },
      COST_CENTER: {
        label: 'Centro de custo',
        description: 'Centro de custo da despesa.',
      },
      DEPARTMENT: {
        label: 'Departamento',
        description: 'Departamento relacionado à despesa.',
      },
    },
  },
  expenseClassification: {
    label: 'Classificação da despesa',
    placeholder: 'Buscar ou informar uma classificação…',
    searchPlaceholder: 'Buscar classificação…',
    triggerPlaceholder: 'Selecionar ou criar…',
    loading: 'Carregando classificações…',
    empty: 'Sem correspondências na lista.',
    loadError: 'Não foi possível carregar as categorias. Tente novamente.',
    createOption: 'Usar "{{value}}"',
    helper:
      'Sugestões genéricas ou texto livre: o texto que você escolher fica apenas nesta solicitação.',
    validationRequired: 'Informe a classificação da despesa',
  },
  requestForm: {
    title: 'Dados da solicitação',
    description: 'Informações do solicitante e da despesa.',
    noPolicy: 'Sem política',
    policyRules: {
      noDescription: 'Sem descrição da política.',
      transactionLimit: 'Limite por transação',
      periodLimit: 'Limite por período',
      approval: 'Aprovação',
      autoApprove: 'Auto-aprovação quando aplicável',
      approvalSteps: '{{count}} etapa(s) de aprovação',
    },
    fields: {
      company: 'Empresa',
      entity: 'Empresa',
      policy: 'Política de reembolso (automática)',
      cpfCnpj: 'CPF ou CNPJ',
      email: 'E-mail',
      name: 'Nome do solicitante',
      merchant: 'Estabelecimento',
      description: 'Descrição da despesa',
      totalAmount: 'Valor total dos comprovantes',
      requestedAmount: 'Valor solicitado',
      expenseDate: 'Data da despesa',
      reimbursementDueDate: 'Data solicitada para reembolso',
      pixKey: 'Chave Pix',
      payoutMethod: 'Forma de recebimento',
      bankCode: 'Banco',
      bankAgency: 'Agência',
      bankAccount: 'Conta',
      bankAccountType: 'Tipo de conta',
      department: 'Departamento',
      costCenter: 'Centro de custo',
      businessJustification: 'Justificativa de negócio',
      attachments: 'Anexos',
      expenseClassification: 'Classificação da despesa',
    },
    placeholders: {
      company: 'Selecione a empresa',
      entity: 'Selecione a empresa',
      policy: 'Identificada automaticamente após enviar',
      cpfCnpj: 'Somente números ou formatado',
      email: 'email@empresa.com',
      name: 'Nome para cadastro quando não houver fornecedor',
      description: 'Detalhe a natureza da despesa',
      pixKey: 'E-mail, telefone, CPF/CNPJ ou chave aleatória',
      bankSearch: 'Buscar por nome ou código...',
      bankCode: 'Ex.: 341',
      bankAgency: 'Ex.: 1234',
      bankAccount: 'Número da conta',
      bankAccountDigit: 'Dígito',
      businessJustification: 'Explique o motivo e o contexto',
      expenseClassification: 'Ex.: vendas, viagens — ou informe uma categoria própria',
    },
    merchant: {
      linkedBadge: 'Vinculado',
      linkedFallback: 'Fornecedor selecionado',
      linkedNoDetails: 'Sem detalhes adicionais.',
      willResolveOnSubmit:
        'Ao enviar, vamos tentar vincular a um fornecedor cadastrado. O gestor poderá ajustar.',
      searchOrType:
        'Selecione um fornecedor cadastrado ou informe nome e CNPJ/CPF do estabelecimento.',
      publicHint:
        'Informe o nome e o CNPJ ou CPF do estabelecimento. O gestor confirmará o fornecedor depois.',
      lookingUp: 'Buscando fornecedor',
      searchVendor: 'Buscar fornecedor',
      swap: 'Trocar',
      swapAria: 'Trocar fornecedor vinculado',
      clear: 'Limpar',
      clearAria: 'Remover vínculo com fornecedor',
      searchPlaceholder: 'Buscar fornecedor por nome, fantasia ou documento...',
      searchEmpty: 'Nenhum fornecedor disponível.',
      searchNotFound: 'Nenhum fornecedor encontrado.',
      namePlaceholder: 'Nome do estabelecimento',
      nameAria: 'Nome do estabelecimento',
      taxIdPlaceholder: 'CNPJ ou CPF do estabelecimento (opcional)',
      taxIdAria: 'CNPJ ou CPF do estabelecimento',
      suggestionsHeading: 'Encontrámos fornecedores parecidos. Clica para vincular:',
      suggestionAria: 'Vincular ao fornecedor {{name}}',
    },
    helpers: {
      name: 'Obrigatório quando não encontramos um fornecedor ou contraparte com estes dados.',
      attachments: '{{count}} arquivo(s) selecionado(s). Serão enviados após criar a solicitação.',
      paymentSchedule:
        'A data prevista do reembolso é definida automaticamente (envio + 7 dias) e só pode ser alterada pelo gestor na análise do pedido.',
      pixKeySharedBatch: 'Os mesmos dados de pagamento valem para todos os pedidos deste envio.',
      payoutMethod: 'Escolha Pix ou transferência bancária (TED).',
    },
    payout: {
      pix: 'Pix',
      ted: 'Transferência (TED)',
      accountChecking: 'Conta corrente',
      accountSavings: 'Conta poupança',
    },
    sections: {
      entity: {
        title: 'Entidade',
        description: 'Empresa ou filial vinculada a este pedido.',
      },
      attachments: {
        title: 'Arquivos',
        description:
          'Envie os comprovantes em PDF ou imagem. A análise por IA pode sugerir o preenchimento dos campos.',
      },
      payment: {
        title: 'Dados para pagamento',
        description: 'Chave Pix ou conta bancária para receber o reembolso.',
      },
      requester: {
        title: 'Dados do solicitante',
        description: 'Identificação e contato de quem solicita o reembolso.',
        batchHint:
          'No envio com vários pedidos, estes dados são compartilhados por todos os blocos abaixo.',
      },
      expense: {
        title: 'Dados da despesa',
        description: 'Classificação, fornecedor, valores e demais detalhes do gasto.',
      },
      orders: {
        title: 'Pedidos',
        description: 'Cada bloco corresponde a um pedido que será criado ao enviar.',
      },
    },
    multiBatch: {
      generalTitle: 'Dados gerais',
      generalDescription:
        'Solicitante e pagamento: estes dados são compartilhados por todos os pedidos deste envio.',
      pedidosTitle: 'Pedidos',
    },
    ai: {
      analyzing: 'Analisando anexos com IA…',
      analyzingHint: 'Aguarde enquanto lemos os comprovantes.',
      filledByAi: 'IA',
      editHint: 'Edite o campo para ajustar o valor sugerido.',
      extractionFailed:
        'Não foi possível analisar os anexos com IA. Você pode preencher os campos manualmente.',
      couldNotRead:
        'Não foi possível ler este comprovante. Tente enviar uma foto mais nítida ou preencha os campos manualmente.',
      partiallyFilled:
        'A IA preencheu apenas parte dos dados. Revise os campos abaixo ou envie uma foto mais legível.',
      tryAnotherPhoto: 'Tentar outra foto',
      continueManually: 'Continuar com esta imagem e preencher manualmente',
    },
    aiGrouping: {
      title: 'Sugestão da IA',
      confidence: 'Confiança {{percent}}%',
      followingAi: 'Seguindo sugestão da IA',
      userOverride: 'Sua escolha sobrescreve a IA',
      modeSingle: 'Manter como 1 pedido',
      modeMultiple: 'Dividir em {{count}} pedidos',
      multipleNeedsMoreFiles: 'Inclua pelo menos 2 comprovantes para dividir em vários pedidos.',
      multipleEditingHint: 'Edite cada card abaixo. Ao enviar, criaremos um pedido para cada card.',
      groupBadge: 'Pedido {{index}} de {{total}}',
      groupAttachments: '{{count}} anexo(s) neste pedido',
      groupProcessing: 'Processando {{count}} arquivo(s) — você pode editar os campos.',
      cardTitle: 'Pedido {{index}}',
      removePedidoAria: 'Remover este pedido e os respectivos comprovantes da lista',
    },
    upload: {
      dropTitle: 'Arraste arquivos aqui ou use os botões abaixo',
      dropHint: 'Formatos suportados: PDF, PNG, JPG (até {{max}} arquivos)',
      dropActive: 'Solte os arquivos aqui',
      selectFiles: 'Escolher da galeria',
      takePhoto: 'Tirar foto',
      filesSelected: '{{count}} arquivo(s) selecionado(s)',
    },
    fileStatus: {
      analyzing: 'Analisando com IA…',
      ready: 'Analisado',
      partial: 'Preenchido parcialmente',
      failed: 'Não foi possível ler',
      retry: 'Reanalisar',
    },
    buttons: {
      submit: 'Enviar solicitação',
      submitting: 'Enviando...',
      submitMultiple: 'Enviar {{count}} pedidos',
      back: 'Voltar',
      continue: 'Continuar',
      continueToExpense: 'Continuar para dados da despesa',
      continueToPayment: 'Continuar para pagamento',
    },
    steps: {
      label: 'Etapas da solicitação de reembolso',
      attachments: 'Comprovantes',
      expense: 'Dados da despesa',
      payment: 'Você e o pagamento',
      count: '{{step}} de 3',
    },
    cancelDialog: {
      title: 'Cancelar solicitação?',
      description: 'Os dados preenchidos serão perdidos. Deseja voltar ao painel do gestor?',
      keepEditing: 'Continuar editando',
      confirm: 'Ir para o painel',
    },
    validation: {
      entity: 'Selecione a empresa',
      cpfCnpj: 'Informe o CPF ou CNPJ',
      cpfCnpjInvalid: 'Informe um CPF com 11 dígitos ou CNPJ com 14 dígitos',
      email: 'Informe um e-mail válido',
      name: 'Informe o nome do solicitante',
      expenseClassification: 'Selecione a classificação da despesa',
      reviewFields: 'Corrija os campos indicados no formulário antes de enviar',
      expenseDate: 'Informe a data da despesa',
      reimbursementDueDate: 'Informe a data solicitada para reembolso',
      description: 'Informe a descrição da despesa',
      totalAmount: 'Informe o valor total dos comprovantes (maior que zero)',
      requestedAmount: 'Informe o valor solicitado (maior que zero)',
      requestedExceedsTotal:
        'O valor solicitado não pode ser maior que o valor total dos comprovantes',
      attachmentsToContinue: 'Envie pelo menos um comprovante para continuar',
      pixKey: 'Informe a chave Pix',
      payout: 'Informe a chave Pix ou os dados bancários para TED',
      payoutBank: 'Selecione o banco',
      payoutAgency: 'Informe a agência',
      payoutAccount: 'Informe a conta',
      costCenter: 'Selecione o centro de custo',
      department: 'Selecione o departamento',
      attachments: 'Inclua pelo menos um anexo',
      businessJustification: 'Informe a justificativa exigida pela política',
      submit: 'Não foi possível enviar a solicitação',
      nameWhenNoMatch:
        'Informe o nome completo quando não houver fornecedor cadastrado com estes dados',
    },
  },
  limits: {
    perTransaction: 'Por transação',
    perPeriod: 'Por período',
    autoApprove: 'Auto-aprovar até',
    noLimit: 'Sem limite',
    alwaysApprove: 'Sempre aprovar',
    periodLabels: {
      MONTHLY: 'mês',
      QUARTERLY: 'tri',
      YEARLY: 'ano',
    },
  },
  badges: {
    active: 'Ativa',
    inactive: 'Inativa',
    priority: 'Prioridade',
    perRequester: 'Limite por solicitante',
    globalPeriod: 'Limite acumulado do período',
    requiresJustification: 'Exige justificativa',
    aiPolicy: 'Política IA',
  },
  steps: {
    info: 'Informações Básicas',
    limits: 'Limites',
    conditions: 'Condições',
    approval: 'Aprovação',
    review: 'Regras Adicionais',
  },
  form: {
    nameLabel: 'Nome da Política',
    namePlaceholder: 'Ex: Alimentação, Transporte...',
    descriptionLabel: 'Descrição',
    descriptionPlaceholder: 'Descreva quando esta política deve ser aplicada...',
    activeLabel: 'Política ativa',
    activeHelper: 'Políticas inativas não são aplicadas a novos reembolsos.',
    evaluationModeLabel: 'Modo de avaliação',
    evaluationModeHelper:
      'Determinístico usa workflow e limites numéricos. IA interpreta o texto da política quando o pedido é enviado.',
    evaluationDeterministic: 'Determinístico',
    evaluationDeterministicHelper:
      'Use condições, limites e cadeia de aprovação configurados no formulário.',
    evaluationAi: 'Inteligência artificial',
    evaluationAiHelper: 'Descreva as regras em texto para a IA avaliar o pedido automaticamente.',
    aiCategoryLabel: 'Categoria da despesa (filtro opcional)',
    aiCategoryHelper:
      'Quando preenchido, corresponde apenas a pedidos com a mesma classificação de despesa (sem diferenciar maiúsculas).',
    aiCategoryPlaceholder: 'Ex.: Alimentação, Viagens…',
    aiExamplesLabel: 'Modelos de exemplo',
    aiExampleOptionNone: 'Nenhum',
    aiExampleTravel: 'Viagens',
    aiExampleMeals: 'Alimentação',
    aiExampleTraining: 'Treinamento',
    aiPolicyTextLabel: 'Texto da política (instruções para a IA)',
    aiPolicyTextPlaceholder:
      'Escreva instruções claras: o que aprovar, limites, documentação obrigatória e exceções.',
    aiPolicyTextHelper:
      'Este texto é enviado ao modelo junto com o resumo do pedido. Alinhe com jurídico/financeiro antes de publicar.',
    aiCharCount: '{{count}} caracteres',
    aiCopyPreview: 'Copiar texto',
    aiCopyDone: 'Copiado',
    aiDeterministicNote:
      'No modo IA, limites numéricos, condições, aprovação e regras de elegibilidade ficam dentro do texto da política.',
    operationalSettingsTitle: 'Configurações operacionais',
    operationalSettingsAiHelper:
      'Estas opções não alteram a decisão da IA; use apenas para definir a data prevista de pagamento.',
    defaultApprovalStep: 'Aprovação do Gestor',
    priorityLabel: 'Prioridade',
    priorityHelper: 'Prioridades maiores ganham em caso de empate de condições.',
    perTransactionLabel: 'Limite por transação',
    perTransactionHelper: 'Valor máximo por solicitação individual. Deixe vazio para sem limite.',
    autoApproveLabel: 'Auto-aprovar até',
    autoApproveHelper: 'Solicitações até este valor pulam o fluxo de aprovação.',
    periodLimitTitle: 'Limite por período',
    periodLimitHelper: 'Limita o total que cada solicitante pode reembolsar no período.',
    periodMaxLabel: 'Valor máximo',
    periodTypeLabel: 'Tipo de período',
    periodScopeLabel: 'Escopo do limite',
    periodScopeHelper: 'Defina se o limite do período é por solicitante ou global.',
    expenseAgeLabel: 'Máximo de dias desde a despesa',
    payoutSchedule: {
      source: 'Data prevista de pagamento',
      sourceHelp: 'Use a regra global da empresa ou defina uma regra específica desta política.',
      global: 'Usar configuração global',
      specific: 'Configuração específica desta política',
      mode: 'Modo de agendamento',
      modePlaceholder: 'Selecione o modo',
      days: 'Dias',
      offsetDays: 'D+n dias',
      anchor: 'Âncora',
      modes: {
        WEEKDAYS: 'Dias da semana',
        MONTH_DAYS: 'Dias do mês',
        OFFSET_DAYS: 'D+n dias',
      },
      anchors: {
        SUBMISSION: 'Após envio',
        APPROVAL: 'Após aprovação',
      },
      weekdays: {
        '0': 'Dom',
        '1': 'Seg',
        '2': 'Ter',
        '3': 'Qua',
        '4': 'Qui',
        '5': 'Sex',
        '6': 'Sáb',
      },
    },
    requireJustificationLabel: 'Exigir justificativa',
    requireJustificationHelper: 'Solicitações exigirão texto de justificativa.',
    justificationInstructionsLabel: 'Orientações para preenchimento da justificativa',
    justificationInstructionsHelper:
      'Instruções exibidas ao solicitante ao preencher a justificativa (ex.: nome, data de nascimento e idade do(s) filho(s)).',
    justificationInstructionsPlaceholder:
      'Ex.: Na justificativa, elencar nome, data de nascimento e idade do(s) filho(s)...',
    workflowLabel: 'Workflow (opcional)',
    workflowHelper: 'Vincule um fluxo de aprovação existente para gerar cadeias.',
    summaryTitle: 'Resumo',
    summaryFields: {
      name: 'Nome',
      description: 'Descrição',
      active: 'Ativa',
      priority: 'Prioridade',
      limitTransaction: 'Limite por transação',
      limitPeriod: 'Limite por período',
      autoApprove: 'Auto-aprovar até',
      periodScope: 'Escopo do período',
      justification: 'Justificativa',
    },
    buttons: {
      cancel: 'Cancelar',
      back: 'Voltar',
      continue: 'Continuar',
      save: 'Salvar Política',
    },
    requiredMark: ' *',
    validation: {
      name: 'Informe o nome da política',
      approvalStepRequired: 'Inclua pelo menos uma etapa de aprovação ou ative a auto-aprovação',
      periodTypeRequired: 'Selecione o tipo de período',
      periodValueRequired: 'Defina o valor máximo para o período',
      positiveAmount: 'Informe um valor maior que zero.',
      positiveInteger: 'Informe um número inteiro maior que zero.',
      nonNegativeInteger: 'Informe um número inteiro maior ou igual a zero.',
      payoutScheduleModeRequired: 'Selecione a regra de pagamento.',
      payoutScheduleDaysRequired: 'Selecione ao menos um dia.',
      conditionValueRequired: 'Preencha ou remova condições sem valor.',
      autoApproveAboveTransaction: 'Auto-aprovar não pode ser maior que o limite por transação.',
      autoApproveAbovePeriod: 'Auto-aprovar não pode ser maior que o limite do período.',
      justificationInstructionsRequired: 'Informe as orientações da justificativa.',
      aiPolicyText: 'Informe o texto da política para o modo IA',
      title: 'Corrija os campos obrigatórios',
      details: 'Revise os campos destacados antes de salvar.',
    },
    comingSoonConditions:
      'As condições de aplicação serão configuradas no fluxo de aprovação. Configure após salvar.',
    comingSoonApproval:
      'Vincule um fluxo de aprovação existente. Em breve: seleção direta pelo catálogo.',
    entityLabel: 'Entidade (opcional)',
    entityPlaceholder: 'Selecione a entidade',
    noConditions: 'Nenhuma condição configurada',
    joinFirst: 'SE',
    join: 'E/OU',
    joinAnd: 'E',
    joinOr: 'OU',
    fields: {
      category: 'Categoria do reembolso',
      glAccount: 'Conta contábil',
      department: 'Departamento',
      costCenter: 'Centro de custo',
      managerialAccount: 'Conta gerencial',
    },
    removeCondition: 'Remover condição',
    selectAccounts: 'Selecione contas...',
    selectDepartment: 'Qualquer departamento',
    selectCostCenter: 'Selecione centros de custo',
    selectManagerial: 'Selecione contas gerenciais',
    addCondition: 'Adicionar condição',
    autoApproveToggle: 'Auto-aprovar',
    approvalPatternLabel: 'Padrão de aprovação',
  },
  expenseCategories: {
    statusAria: 'Status da categoria',
    columns: {
      usage: 'Em uso',
      usageTooltip:
        'Quantidade de vínculos desta categoria: políticas de reembolso que a referenciam (pol.) e solicitações já enviadas que a selecionaram (req.). Categorias em uso não podem ser excluídas — apenas desativadas.',
      usageInfoAria: 'O que significa Em uso',
    },
    usageBadge: '{{policies}} pol. / {{requests}} req.',
  },
  toasts: {
    created: 'Política criada com sucesso',
    createError: 'Erro ao criar política',
  },
  copilot: {
    open: 'Abrir assistente',
    title: 'Assistente',
    subtitle: 'Analisando formulário...',
    suggestionsTitle: 'Sugestões Baseadas no Contexto',
    pendingTitle: 'Campos Pendentes',
    thinking: 'Analisando contexto...',
    promptPlaceholder: 'Pergunte ou peça para configurar algo...',
    suggestions: {
      food: {
        title: 'Criar política de Alimentação',
        description:
          'Baseado em empresas similares, sugiro limite de R$ 150/transação e R$ 2.000/mês com aprovação do gestor acima de R$ 100.',
        action: 'Aplicar configuração',
      },
      approval: {
        title: 'Adicionar aprovação',
        description:
          'Políticas de reembolso geralmente precisam de pelo menos uma etapa de aprovação para controle financeiro.',
        action: 'Configurar aprovação',
      },
    },
    pendings: {
      name: {
        title: 'Nome da política',
        description: 'ainda não foi preenchido. Posso sugerir com base no tipo de despesa.',
      },
    },
  },
};

export const reimbursementPoliciesEn = {
  settingsHub: {
    title: 'Reimbursements',
    tabs: {
      policies: 'Policies',
      categories: 'Categories',
      form: 'Form',
    },
  },
  title: 'Reimbursement Policies',
  newPolicy: 'New Policy',
  formFieldsButton: 'Form fields',
  publicLinksButton: 'Public links',
  policiesCount: '{{count}} policy',
  policiesCount_plural: '{{count}} policies',
  filters: {
    entity: 'All entities',
  },
  searchPlaceholder: 'Search policies...',
  statusAll: 'All statuses',
  statusActive: 'Active',
  statusInactive: 'Inactive',
  emptyTitle: 'No policies found',
  emptyDescription: 'Adjust the filters or create a new reimbursement policy.',
  refresh: 'Refresh',
  intake: {
    pageTitle: 'New reimbursement request',
    toasts: {
      created: 'Request created successfully',
      uploadPartial:
        'Request created, but some attachments failed to upload. Review documents or try again.',
    },
  },
  publicIntake: {
    pageTitle: 'Reimbursement request',
    poweredBy: 'Powered by',
    pageSubtitle: 'Get a code by email, then enter it below to continue.',
    verifiedPageSubtitle:
      'Code validated. Fill in the reimbursement details to submit the request.',
    requestCode: 'Request code',
    validateCode: 'Validate code',
    companyIdentified: 'Company: {{tenantName}}',
    requestTitle: 'Reimbursement details',
    requestDescription: 'Enter the minimum details. Company-required fields: {{fields}}.',
    defaultFields: 'default',
    attachmentsNeedEmail: 'Request a code with your email to enable receipt upload.',
    attachmentsRequiredHint: 'Upload at least one proof file (PDF or image).',
    submit: 'Submit request',
    toasts: {
      codeSent: 'Code sent',
      codeValidated: 'Code validated',
      requestSent: 'Request submitted',
      uploadPartial:
        'Request recorded, but some attachments failed to upload. Contact AP or try again.',
    },
    errors: {
      codeSend: 'We could not send the code. Please try again in a moment.',
      invalidCode: 'We could not validate the code.',
      validateBeforeSubmit: 'Validate the code before submitting',
      submit: 'Could not submit',
      attachmentsRequired: 'Include at least one attachment.',
      uploadTokenMissing: 'Could not start attachment upload. Try again or contact support.',
      invalidLink: 'Public link is invalid, expired, or revoked.',
      invalidEmail: 'Enter a valid email address (e.g. name@company.com).',
      emailNotRegistered:
        'We could not find reimbursement setup for this email domain. Use the corporate email your company provided, or contact HR or finance.',
      emailDomainNotAuthorized:
        'This email is not on a domain authorized for this form. Use your company email.',
      codeInvalidOrExpired:
        'The code is wrong or has expired. Check the message in your inbox or request a new code.',
      tooManyCodeRequests:
        'Too many attempts in a short time. Wait a few minutes and request the code again.',
      emailSendFailed: 'We could not send the email with the code. Try again or contact support.',
      tenantUnavailable: 'Access could not be completed. Try again later or contact support.',
      tenantNotReady:
        'Your company has not finished reimbursement setup yet. Contact an administrator.',
      requestInvalid: 'We could not process your request. Check the information and try again.',
      networkError: 'Check your internet connection and try again.',
    },
    hints: {
      useCorporateEmail: 'Use the email your company set up for reimbursements.',
      codeInEmail: 'Email delivery — check spam or promotions.',
      autoVerifyFromEmail: 'Validating the code from your email…',
    },
    success: {
      pageSubtitle: 'Here is what to expect next.',
      title: 'Request submitted',
      lead: 'We received your request and any receipts you uploaded. Review timelines follow your company policy.',
      step1: 'Wait for finance, HR, or your manager to follow up, per your internal process.',
      step2: 'Keep original receipts handy until reimbursement is completed, if required.',
      step3: 'If you need help, contact your company’s official channels (finance or HR).',
      newRequest: 'Submit another reimbursement',
      trackRequest: 'Track request',
      trackRequestNumbered: 'Track request {{index}}',
      batchTrackingLead: 'You submitted {{count}} requests. Use the links below to track each one.',
    },
    fields: {
      email: 'Email',
      code: 'Code',
      entity: 'Entity',
      cpfCnpj: 'CPF/CNPJ',
      name: 'Requester name',
      merchant: 'Merchant',
      totalAmount: 'Total receipt amount',
      requestedAmount: 'Requested amount',
      expenseDate: 'Expense date',
      reimbursementDueDate: 'Requested reimbursement date',
      pixKey: 'Pix key',
      description: 'Description',
      businessJustification: 'Justification',
      attachments: 'Attachments',
      expenseClassification: 'Expense classification',
    },
  },
  intakeSettings: {
    title: 'Reimbursement intake fields',
    description: 'Configure which fields are required on the reimbursement request form.',
    save: 'Save fields',
    saving: 'Saving...',
    refresh: 'Reload',
    loading: 'Loading settings...',
    toggleAria: 'Toggle required for {{field}}',
    errors: {
      title: 'Could not load',
      load: 'Could not load required reimbursement intake fields.',
    },
    toasts: {
      saved: 'Required fields saved',
      saveError: 'Could not save required fields',
    },
    publicLink: {
      pageTitle: 'Reimbursement public links',
      pageSubtitle: 'Create, copy, and revoke persistent links for the public request form.',
      title: 'Public employee link',
      formsTitle: 'Reimbursement forms',
      description:
        'Generate a persistent public link to send to employees. The link uses the required fields configured above.',
      entityLabel: 'Entity',
      entityPlaceholder: 'Select the entity',
      descriptionLabel: 'Link description',
      descriptionPlaceholder: 'Example: travel reimbursements',
      availabilityLabel: 'Availability',
      availabilityOptions: {
        INDEFINITE: 'Indefinite',
        ONE_HOUR: '1 hour',
        ONE_DAY: '1 day',
        FIVE_DAYS: '5 days',
        THIRTY_DAYS: '30 days',
      },
      accessModeLabel: 'Who can request',
      accessModeOptions: {
        HCM_EMPLOYEES: 'HCM employees',
        COMPANY_DOMAIN: 'Company domain',
        PUBLIC: 'Public',
      },
      accessModeHints: {
        HCM_EMPLOYEES:
          'Only an active HCM employee email. The code sent to the email is still required.',
        COMPANY_DOMAIN:
          'Accepts emails whose domain is an @domain entry on an active inbox, even without an HCM record. A full address or an empty list does not authorize the domain. The code sent to the email is still required.',
        PUBLIC: 'Accepts any valid email. The code sent to the email is still required.',
      },
      generate: 'Generate link',
      generated: 'Generated link',
      linkColumn: 'Link',
      open: 'Open in a new tab',
      empty: 'No links created.',
      createNew: 'Create new link',
      activeHint: 'Copy and send this link to authorized employees.',
      indefiniteHint: 'Available indefinitely.',
      expiresAt: 'Available until {{date}}.',
      expiredHint: 'This link has expired and can no longer be used.',
      revokedHint: 'This link was revoked and can no longer be used.',
      copy: 'Copy',
      revoke: 'Revoke',
      toasts: {
        generated: 'Public link generated',
        copied: 'Link copied to clipboard',
        copyError: 'Could not copy the link',
        entityRequired: 'Select an entity to generate the link',
        descriptionRequired: 'Enter a description to generate the link',
        generateError: 'Could not generate the public link',
        revoked: 'Public link revoked',
        revokeError: 'Could not revoke the public link',
      },
      errors: {
        load: 'Could not load public links',
      },
    },
    fields: {
      DESCRIPTION: {
        label: 'Description',
        description: 'Detailed expense description.',
      },
      ATTACHMENTS: {
        label: 'Attachments',
        description: 'Receipts and proof of payment.',
      },
      TOTAL_AMOUNT: {
        label: 'Total receipt amount',
        description: 'Total amount across the original expense receipts.',
      },
      REQUESTED_AMOUNT: {
        label: 'Requested amount',
        description: 'Amount requested for reimbursement.',
      },
      PIX_KEY: {
        label: 'Payment details',
        description: 'Pix key or bank transfer (TED) details for reimbursement payment.',
      },
      COST_CENTER: {
        label: 'Cost center',
        description: 'Expense cost center.',
      },
      DEPARTMENT: {
        label: 'Department',
        description: 'Expense department.',
      },
    },
  },
  expenseClassification: {
    label: 'Expense classification',
    placeholder: 'Search or enter a classification…',
    searchPlaceholder: 'Search classification…',
    triggerPlaceholder: 'Select or create…',
    loading: 'Loading classifications…',
    empty: 'No preset matches.',
    loadError: 'Could not load categories. Please try again.',
    createOption: 'Use "{{value}}"',
    helper: 'Generic suggestions or free text — your choice is saved only on this request.',
    validationRequired: 'Expense classification is required',
  },
  requestForm: {
    title: 'Request details',
    description: 'Requester and expense information.',
    noPolicy: 'No policy',
    policyRules: {
      noDescription: 'No policy description.',
      transactionLimit: 'Per-transaction limit',
      periodLimit: 'Period limit',
      approval: 'Approval',
      autoApprove: 'Automatic approval when applicable',
      approvalSteps: '{{count}} approval step(s)',
    },
    fields: {
      company: 'Company',
      entity: 'Company',
      policy: 'Reimbursement policy (automatic)',
      cpfCnpj: 'CPF or CNPJ',
      email: 'Email',
      name: 'Requester name',
      merchant: 'Merchant',
      description: 'Expense description',
      totalAmount: 'Total receipt amount',
      requestedAmount: 'Requested amount',
      expenseDate: 'Expense date',
      reimbursementDueDate: 'Requested reimbursement date',
      pixKey: 'Pix key',
      payoutMethod: 'How to receive payment',
      bankCode: 'Bank',
      bankAgency: 'Branch',
      bankAccount: 'Account',
      bankAccountType: 'Account type',
      department: 'Department',
      costCenter: 'Cost center',
      businessJustification: 'Business justification',
      attachments: 'Attachments',
      expenseClassification: 'Expense classification',
    },
    placeholders: {
      company: 'Select company',
      entity: 'Select company',
      policy: 'Identified automatically after submit',
      cpfCnpj: 'Digits only or formatted',
      email: 'you@company.com',
      name: 'Name used when no vendor match is found',
      description: 'Describe the expense',
      pixKey: 'Email, phone, tax ID, or random key',
      bankSearch: 'Search by name or code...',
      bankCode: 'e.g. 341',
      bankAgency: 'e.g. 1234',
      bankAccount: 'Account number',
      bankAccountDigit: 'Digit',
      businessJustification: 'Explain purpose and context',
      expenseClassification: 'e.g. travel, purchases — or enter your own category',
    },
    merchant: {
      linkedBadge: 'Linked',
      linkedFallback: 'Selected vendor',
      linkedNoDetails: 'No additional details.',
      willResolveOnSubmit:
        'On submit, we will try to link an existing vendor. The manager can adjust it.',
      searchOrType: 'Pick a registered vendor or enter the merchant name and CNPJ/CPF.',
      publicHint:
        'Enter the merchant name and CNPJ/CPF. The manager will confirm the vendor later.',
      lookingUp: 'Searching vendors',
      searchVendor: 'Search vendor',
      swap: 'Change',
      swapAria: 'Change linked vendor',
      clear: 'Clear',
      clearAria: 'Remove vendor link',
      searchPlaceholder: 'Search vendor by name, trade name, or tax id...',
      searchEmpty: 'No vendors available.',
      searchNotFound: 'No matching vendors.',
      namePlaceholder: 'Merchant name',
      nameAria: 'Merchant name',
      taxIdPlaceholder: 'Merchant CNPJ or CPF (optional)',
      taxIdAria: 'Merchant CNPJ or CPF',
      suggestionsHeading: 'We found similar vendors. Click to link:',
      suggestionAria: 'Link to vendor {{name}}',
    },
    helpers: {
      name: 'Required when we cannot match an existing vendor or counterparty with these details.',
      attachments: '{{count}} file(s) selected. They will upload after the request is created.',
      paymentSchedule:
        'The expected reimbursement date is set automatically (submission + 7 days) and can only be changed by the manager during review.',
      pixKeySharedBatch: 'The same payment details apply to every request in this submission.',
      payoutMethod: 'Choose Pix or bank transfer (TED).',
    },
    payout: {
      pix: 'Pix',
      ted: 'Bank transfer (TED)',
      accountChecking: 'Checking account',
      accountSavings: 'Savings account',
    },
    sections: {
      entity: {
        title: 'Entity',
        description: 'Company or branch this request belongs to.',
      },
      attachments: {
        title: 'Files',
        description:
          'Upload receipt files (PDF or image). AI analysis may suggest values for the form.',
      },
      payment: {
        title: 'Payment details',
        description: 'Pix key or bank account to receive the reimbursement.',
      },
      requester: {
        title: 'Requester details',
        description: 'Identity and contact information for the person requesting reimbursement.',
        batchHint:
          'When submitting multiple requests together, these details apply to every block below.',
      },
      expense: {
        title: 'Expense details',
        description: 'Classification, merchant, amounts, and other expense information.',
      },
      orders: {
        title: 'Requests',
        description: 'Each block becomes one reimbursement request when you submit.',
      },
    },
    multiBatch: {
      generalTitle: 'Shared details',
      generalDescription:
        'Requester and payout: these fields apply to every request you submit together.',
      pedidosTitle: 'Requests',
    },
    ai: {
      analyzing: 'Analyzing attachments with AI…',
      analyzingHint: 'Wait while we read your receipts.',
      filledByAi: 'AI',
      editHint: 'Edit the field to adjust the suggested value.',
      extractionFailed:
        'Could not analyze the attachments with AI. You can fill in the fields manually.',
      couldNotRead:
        'Could not read this receipt. Try a clearer photo or fill in the fields manually.',
      partiallyFilled:
        'AI filled only part of the data. Review the fields below or upload a clearer photo.',
      tryAnotherPhoto: 'Try another photo',
      continueManually: 'Continue with this image and fill in manually',
    },
    aiGrouping: {
      title: 'AI suggestion',
      confidence: 'Confidence {{percent}}%',
      followingAi: 'Following AI suggestion',
      userOverride: 'Your choice overrides AI',
      modeSingle: 'Keep as 1 request',
      modeMultiple: 'Split into {{count}} requests',
      multipleNeedsMoreFiles: 'Include at least 2 receipts to split into multiple requests.',
      multipleEditingHint: 'Edit each card below. On submit we will create one request per card.',
      groupBadge: 'Request {{index}} of {{total}}',
      groupAttachments: '{{count}} attachment(s) in this request',
      groupProcessing: 'Processing {{count}} file(s) — you can still edit the fields.',
      cardTitle: 'Request {{index}}',
      removePedidoAria: 'Remove this request and its attachments from the selection',
    },
    upload: {
      dropTitle: 'Drag files here or use the buttons below',
      dropHint: 'Supported formats: PDF, PNG, JPG (up to {{max}} files)',
      dropActive: 'Drop files here',
      selectFiles: 'Choose from gallery',
      takePhoto: 'Take photo',
      filesSelected: '{{count}} file(s) selected',
    },
    fileStatus: {
      analyzing: 'Analyzing with AI…',
      ready: 'Analyzed',
      partial: 'Partially filled',
      failed: 'Could not read',
      retry: 'Reanalyze',
    },
    buttons: {
      submit: 'Submit request',
      submitting: 'Submitting...',
      submitMultiple: 'Submit {{count}} requests',
      back: 'Back',
      continue: 'Continue',
      continueToExpense: 'Continue to expense details',
      continueToPayment: 'Continue to payment',
    },
    steps: {
      label: 'Reimbursement request steps',
      attachments: 'Receipts',
      expense: 'Expense details',
      payment: 'You and payment',
      count: '{{step}} of 3',
    },
    cancelDialog: {
      title: 'Cancel this request?',
      description: 'Any entered data will be discarded. Return to the manager dashboard?',
      keepEditing: 'Keep editing',
      confirm: 'Go to manager dashboard',
    },
    validation: {
      entity: 'Select a company',
      cpfCnpj: 'CPF or CNPJ is required',
      cpfCnpjInvalid: 'Enter a CPF with 11 digits or CNPJ with 14 digits',
      email: 'Enter a valid email',
      name: 'Requester name is required',
      reviewFields: 'Fix the highlighted fields in the form before submitting',
      expenseDate: 'Expense date is required',
      reimbursementDueDate: 'Requested reimbursement date is required',
      description: 'Description is required',
      totalAmount: 'Total receipt amount must be greater than zero',
      requestedAmount: 'Requested amount must be greater than zero',
      requestedExceedsTotal: 'Requested amount cannot exceed total receipt amount',
      attachmentsToContinue: 'Upload at least one receipt to continue',
      pixKey: 'Pix key is required',
      payout: 'Enter a Pix key or bank details for TED',
      payoutBank: 'Select a bank',
      payoutAgency: 'Enter the branch number',
      payoutAccount: 'Enter the account number',
      costCenter: 'Select a cost center',
      department: 'Select a department',
      attachments: 'Add at least one attachment',
      businessJustification: 'Business justification is required by this policy',
      expenseClassification: 'Expense classification is required',
      submit: 'Could not submit the request',
      nameWhenNoMatch: 'Full name is required when no vendor exists for these details',
    },
  },
  limits: {
    perTransaction: 'Per transaction',
    perPeriod: 'Per period',
    autoApprove: 'Auto-approve up to',
    noLimit: 'No limit',
    alwaysApprove: 'Always require approval',
    periodLabels: {
      MONTHLY: 'month',
      QUARTERLY: 'quarter',
      YEARLY: 'year',
    },
  },
  badges: {
    active: 'Active',
    inactive: 'Inactive',
    priority: 'Priority',
    perRequester: 'Per requester limit',
    globalPeriod: 'Global period limit',
    requiresJustification: 'Requires justification',
    aiPolicy: 'AI policy',
  },
  steps: {
    info: 'Basic Info',
    limits: 'Limits',
    conditions: 'Conditions',
    approval: 'Approval',
    review: 'Additional Rules',
  },
  form: {
    nameLabel: 'Policy name',
    namePlaceholder: 'e.g. Meals, Transport',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Describe when this policy should apply...',
    activeLabel: 'Policy active',
    activeHelper: 'Inactive policies are not applied to new reimbursements.',
    evaluationModeLabel: 'Evaluation mode',
    evaluationModeHelper:
      'Deterministic mode uses workflows and numeric limits. AI mode interprets policy text when the request is submitted.',
    evaluationDeterministic: 'Deterministic',
    evaluationDeterministicHelper:
      'Use conditions, limits, and approval routing configured in the form.',
    evaluationAi: 'Artificial intelligence',
    evaluationAiHelper: 'Describe rules in text so AI can evaluate the request automatically.',
    aiCategoryLabel: 'Expense category (optional filter)',
    aiCategoryHelper:
      'When set, only matches requests with the same expense classification (case-insensitive).',
    aiCategoryPlaceholder: 'e.g. Meals, Travel…',
    aiExamplesLabel: 'Example templates',
    aiExampleOptionNone: 'None',
    aiExampleTravel: 'Travel',
    aiExampleMeals: 'Meals',
    aiExampleTraining: 'Training',
    aiPolicyTextLabel: 'Policy text (model instructions)',
    aiPolicyTextPlaceholder:
      'Write clear rules: what to approve, limits, required documents, and exceptions.',
    aiPolicyTextHelper:
      'This text is sent to the model with a summary of the request. Align with legal/finance before publishing.',
    aiCharCount: '{{count}} characters',
    aiCopyPreview: 'Copy text',
    aiCopyDone: 'Copied',
    aiDeterministicNote:
      'In AI mode, numeric limits, conditions, approval, and eligibility rules live in the policy text.',
    operationalSettingsTitle: 'Operational settings',
    operationalSettingsAiHelper:
      'These options do not change the AI decision; use them only to define the expected payment date.',
    defaultApprovalStep: 'Manager approval',
    priorityLabel: 'Priority',
    priorityHelper: 'Higher priorities win when conditions tie.',
    perTransactionLabel: 'Per-transaction limit',
    perTransactionHelper: 'Maximum per request. Leave empty for no limit.',
    autoApproveLabel: 'Auto-approve up to',
    autoApproveHelper: 'Requests up to this value skip approval workflow.',
    periodLimitTitle: 'Period limit',
    periodLimitHelper: 'Total allowed in the period.',
    periodMaxLabel: 'Max amount',
    periodTypeLabel: 'Period type',
    periodScopeLabel: 'Limit scope',
    periodScopeHelper: 'Choose if the period limit is per requester or global.',
    expenseAgeLabel: 'Max days since expense',
    payoutSchedule: {
      source: 'Expected payment date',
      sourceHelp: 'Use the company global rule or define a policy-specific rule.',
      global: 'Use global settings',
      specific: 'Policy-specific settings',
      mode: 'Scheduling mode',
      modePlaceholder: 'Select mode',
      days: 'Days',
      offsetDays: 'D+n days',
      anchor: 'Anchor',
      modes: {
        WEEKDAYS: 'Days of the week',
        MONTH_DAYS: 'Days of the month',
        OFFSET_DAYS: 'D+n days',
      },
      anchors: {
        SUBMISSION: 'After submission',
        APPROVAL: 'After approval',
      },
      weekdays: {
        '0': 'Sun',
        '1': 'Mon',
        '2': 'Tue',
        '3': 'Wed',
        '4': 'Thu',
        '5': 'Fri',
        '6': 'Sat',
      },
    },
    requireJustificationLabel: 'Require justification',
    requireJustificationHelper: 'Requests must include a justification text.',
    justificationInstructionsLabel: 'Justification filling instructions',
    justificationInstructionsHelper:
      'Instructions shown to the requester when filling the justification (e.g. child name, DOB, age).',
    justificationInstructionsPlaceholder:
      'e.g. In the justification, list name, date of birth and age of child(ren)...',
    workflowLabel: 'Workflow (optional)',
    workflowHelper: 'Link an approval workflow to generate approval chains.',
    summaryTitle: 'Summary',
    summaryFields: {
      name: 'Name',
      description: 'Description',
      active: 'Active',
      priority: 'Priority',
      limitTransaction: 'Per-transaction limit',
      limitPeriod: 'Period limit',
      autoApprove: 'Auto-approve up to',
      periodScope: 'Period scope',
      justification: 'Justification',
    },
    buttons: {
      cancel: 'Cancel',
      back: 'Back',
      continue: 'Continue',
      save: 'Save Policy',
    },
    requiredMark: ' *',
    validation: {
      name: 'Please enter the policy name',
      approvalStepRequired: 'Add at least one approval step or enable auto-approve',
      periodTypeRequired: 'Select the period type',
      periodValueRequired: 'Provide the period maximum amount',
      positiveAmount: 'Enter an amount greater than zero.',
      positiveInteger: 'Enter a whole number greater than zero.',
      nonNegativeInteger: 'Enter a whole number greater than or equal to zero.',
      payoutScheduleModeRequired: 'Select the payment rule.',
      payoutScheduleDaysRequired: 'Select at least one day.',
      conditionValueRequired: 'Fill in or remove conditions without a value.',
      autoApproveAboveTransaction: 'Auto-approve cannot be greater than the per-transaction limit.',
      autoApproveAbovePeriod: 'Auto-approve cannot be greater than the period limit.',
      justificationInstructionsRequired: 'Provide the justification instructions.',
      aiPolicyText: 'Enter the policy text for AI mode',
      title: 'Fix the required fields',
      details: 'Review the highlighted fields before saving.',
    },
    comingSoonConditions:
      'Conditions will be configured in the approval workflow. Configure after saving.',
    comingSoonApproval: 'Link an existing workflow. Soon: direct selection from the catalog.',
    entityLabel: 'Entity (optional)',
    entityPlaceholder: 'Select the entity',
    noConditions: 'No conditions configured',
    joinFirst: 'IF',
    join: 'AND/OR',
    joinAnd: 'AND',
    joinOr: 'OR',
    fields: {
      category: 'Reimbursement category',
      glAccount: 'GL account',
      department: 'Department',
      costCenter: 'Cost center',
      managerialAccount: 'Managerial account',
    },
    removeCondition: 'Remove condition',
    selectAccounts: 'Select accounts…',
    selectDepartment: 'Any department',
    selectCostCenter: 'Select cost centers',
    selectManagerial: 'Select managerial accounts',
    addCondition: 'Add condition',
    autoApproveToggle: 'Auto-approve',
    approvalPatternLabel: 'Approval pattern',
  },
  expenseCategories: {
    statusAria: 'Category status',
    columns: {
      usage: 'In use',
      usageTooltip:
        'How many links reference this category: reimbursement policies (pol.) and submitted requests that selected it (req.). Categories in use cannot be deleted — only deactivated.',
      usageInfoAria: 'What In use means',
    },
    usageBadge: '{{policies}} pol. / {{requests}} req.',
  },
  toasts: {
    created: 'Policy created successfully',
    createError: 'Failed to create policy',
  },
  copilot: {
    open: 'Open assistant',
    title: 'Assistant',
    subtitle: 'Analyzing form...',
    suggestionsTitle: 'Context-based suggestions',
    pendingTitle: 'Pending fields',
    thinking: 'Analyzing context...',
    promptPlaceholder: 'Ask or request a configuration...',
    suggestions: {
      food: {
        title: 'Create Meals policy',
        description:
          'Based on similar companies, we suggest BRL 150 per transaction and BRL 2,000 per month with manager approval above BRL 100.',
        action: 'Apply configuration',
      },
      approval: {
        title: 'Add approval',
        description:
          'Reimbursement policies usually need at least one approval step for financial control.',
        action: 'Configure approval',
      },
    },
    pendings: {
      name: {
        title: 'Policy name',
        description: 'is still empty. I can suggest one based on expense type.',
      },
    },
  },
};
